import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=aa23c95a&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aa23c95a')) {
      api.createRecord('aa23c95a', component.options)
    } else {
      api.reload('aa23c95a', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=aa23c95a&", function () {
      api.rerender('aa23c95a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-270j5iEt9DSqh/JS/comp/IncreaseNumber.vue"
export default component.exports